import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        minWidth: '400px',
        borderBottom: '1px solid #80808057',
        padding: '10px 24px',
        fontWeight: 500
    }

}))
export default function ConfirmBox(props) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        props.handleClose()
    };


    const disagree = () => {
        props.handleClose()
    }
    const accept = () => {
        props.accept()
    }
    const classes = useStyles();


    return (
        <div>

            <Dialog
                open={props.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <h6 className={classes.dialogTitle}>Confirm</h6>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{
                        color: 'black'
                    }}>

                        {props.message}
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Button onClick={disagree} color="secondary" style={{ textTransform: 'none' }}>
                        Cancel
                    </Button>
                    <Button onClick={accept} color="primary" style={{ textTransform: 'none' }}>
                        Confirm
                     </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}